import { App } from "./core/App.js";

window.onload = function()
{
    const app = new App();
    app.run();
};
